export function degreeToRadian(degree) {
    return (degree * Math.PI) / 180;
}
export function radianToDegree(radian) {
    return (radian * 180) / Math.PI;
}
export function isEqualAngle(angle, angle2) {
    return normalizeAngle(angle) === normalizeAngle(angle2);
}
export function normalizeAngle(angle) {
    return ((angle % 360) + 360) % 360;
}
export function angleToSvgCoordinates(angle, radius) {
    const radian = degreeToRadian(angle);
    return {
        x: Math.sin(radian) * radius,
        y: -Math.cos(radian) * radius,
    };
}
export function svgCoordinatesToAngle(x, y) {
    const angle = radianToDegree(Math.atan2(x, -y));
    return normalizeAngle(angle);
}
